import { render, staticRenderFns } from "./ProjectImpactMainDialog.vue?vue&type=template&id=71b1106a&scoped=true&"
import script from "./ProjectImpactMainDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectImpactMainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b1106a",
  null
  
)

export default component.exports